export default {
  common: {
    contactUs: "Контактирајте нѐ.",
    tryForFree: "Бесплатен пробен период"
  },
  header: {
    navItems: {
      item1: "Почетна",
      item2: "Бенефити",
      item3: "Помош",
      item4: "Контакт",
      item5: "Најави се",
    },
  },
  footer: {
    text: "Inspect Master <3> Copyright © 2023 </3> <1></1> <2> Tremium Software.</2> Сите права се задржани.",
    supportLink: "im.support@tremium.net",
    navItems: {
      item1: "Почетна",
      item2: "Бенефити",
      item3: "Демо",
      item4: "Помош",
      item5: "Политика на приватност",
      item6: "Контакт",
    },
  },
  sectionHero: {
    title: "Проверка на процесите. Автоматизација на контролата. Заштеда на време.",
    text: "Inspect Master претставува решение за сите Ваши потреби во областа на проверката на безбедносните услови при работа. Нашата платформа овозможува автоматизација, стандардизација и систематско водење на податоци, решавајќи ги клучните предизвици co кои ce соочуваат традиционалните процеси на проверка.",
    buttonLabel: "Контактирајте нѐ.",
  },
  sectionWhy: {
    title: "Зошто токму Inspect Master?",
    cards: {
      card1: {
        title: "Автоматизација",
        text: "Процесот на проверка е автоматизиран од самиот почеток па сè до изработка на стручниот наод како краен производ. Автоматизацијата на процесите заштедува време и овозможува ефикасност во работата.",
      },
      card2: {
        title: "Прилагодливост",
        text: "Со користење на персонализирани шаблони, нашата платформа овозможува прилагодување на процесот на проверка на секаков тип испитување.",
      },
      card3: {
        title: "Без грешки",
        text: "Преку подготовка на шаблони кои прецизно водат низ целиот процес на проверка, се намалува можноста за грешка и се зголемува ефикасноста во работата.",
      },
      card4: {
        title: "Заштеда на време",
        text: "Заборавете на процеси што одземаат многу време и на долготрајно креирање извештаи. Inspect Master автоматски генерира стручни наоди и извештаи, штедејќи време за внесување и обработка на податоци.",
      },
      card5: {
        title: "Администрација и структура",
        text: "Нашата апликација овозможува лесно управување со сите параметри потребни за креирање на наоди. Стручниот наод е главен документ на апликацијата, а нашиот систем овозможува пребарување и филтрирање на податоците според Вашите потреби.",
      },
    },
  },
  sectionInfo: {
    text: "Рачното водење податоци и недостигот на документација стануваат минато со нашето софтверско решение. Inspect Master овозможува брз и ефикасен внес на податоци преку компјутер, телефон и таблет, што го олеснува теренската работа. <br /><br /> Со цел забрзување и стандардизација на процесот на проверка, нашата апликација генерира стручен наод креиран според однапред подготвени шаблони и во согласност со важечките прописи.",
  },
  sectionMakePossible: {
    title: "Што овозможува <br /> Inspect Master?",
    items: [
      "Можност за внесување на резултати од испитувања преку текст, слика или табела",
      "Формирање на стручен наод по внесувањето на податоците од испитувањето",
      "Извезување на стручните наоди во PDF формат",
      "Автоматско извезување на стручните наоди преку е-пошта",
      "Можност за копирање на постоечки наоди",
      "Користење на уреди за брз внес на податоци",
      "Архивирање на стручните наоди и чување резервни копии на cloud",
      "Можност за креирање шаблони кои служат за автоматизација на проверката на процеси и опрема за работа согласно барањата и стандардите (кои се) специфичнии за одредена индустрија",
      "Пребарување и брз пристап до сите стручни наоди",
    ],
  },
  sectionTrial: {
    title: "Регистрирајте се - првиот месец е <br /> бесплатен!",
    text1: "Бесплатната верзија вклучува:",
    text2:
      "По истекот на бесплатниот месец, контактирајте нè за понуди и продолжување на лиценцата.",
    trialList: [
      "Неограничен број корисници и стручни наоди",
      "Испраќање извештаи по е-пошта во моментот на затворање на наодот",
      "Подесување за печатење и пристап до шаблони",
      "Копирање на предметот на испитување и стручниот наод",
      "Чување на извештаи на Cloud во моментот на затворање на наодот",
      "Страна за управување со документи (Document Management)",
    ],
  },
  sectionFAQ: {
    title: "Често поставувани прашања",
    note: "Сè уште имате прашање?",
    questions: {
      question1: {
        question: "Како да се регистрирате на платформата?",
        answer:
          "Со само еден повик или е-пошта! Првата регистрација за Вашиот тим на платформата Ja, отвара тимот за поддршка на Inspect Master, при што Ви се доделува улога на администратор. Потоа, администраторот има можност да додава останати членови на тимот и да им доделува различни улоги во рамки на платформата. ",
      },
      question2: {
        question: "Кои се најважните сегменти на Inspect Master?",
        answer:
          "Предметите на испитување, кои се состојат од повеќе секции, претставуваат основен дел од апликацијата. Тие се креираат пред самото испитување со цел да се олеснат понатамошните проверки.Покрај предметите на испитување, стручните наоди се крајниот документ што се добива по испитувањето на терен. Тие се генерираат со пополнување на резултатите од испитувањето директно на терен.",
      },
      question3: {
        question: "Како се дефинираат <i>параметрите</i> на испитувањето?",
        answer:
          "Во рамки на платформата, потребно е да се дефинираат неопходните параметри: областите на работа со кои се занимава компанијата (Типови на испитувања), прописите и стандардите што ќе се применуваат при испитувањата, инструментите со кои ќе се вршат испитувањата, како и клиентите за кои се врши испитувањето. ",
      },
      question4: {
        question: "Како се дефинираат <i>предметите</i> на испитување?",
        answer:
          "Предметите на испитување можат да се предефинираат на два начини: со увоз од заедничката библиотека или со самостојно креирање. При самостојно креирање на наодот, потребно е да се дефинира типот на наод, инструментите со кои се врши испитувањето и прописите и стандардите што се применуваат. Потоа се подготвуваат прашањата на кои треба да се одговори при пополнување на стручниот наод. Дополнително, можно е однапред да се дефинираат заклучоци, како и одговори на прашањата, со цел да се оптимизира времето за внес на терен. ",
      },
      question5: {
        question: "Како се внесуваат резултатите од испитувањето?",
        answer:
          "Одговорите на однапред подготвените прашања во стручниот наод се внесуваат во форма на текст, пополнување табела, прикачување слика или избор на една од понудените опции. На крајот се формира заклучок — позитивен или негативен. Еден стручен наод може да содржи повеќе предмети на испитување.",
      },
      question6: {
        question: "Кои се дополнителните функционалности?",
        answer:
          "Покрај примарните функционалности, дополнителни можности на Inspect Master се автоматското зачувување на стручните наоди и шаблоните. Стручните наоди можат да се зачуваат на Cloud или директно да се испратат на е-пошта на клиентите. Голема предност се и шаблонските, однапред дефинирани одговори на најчестите прашања, кои можат автоматски да се додадат во стручниот наод, како и веќе подготвени шаблони за испитувања.",
      },
    },
  },
  sectionAbout: {
    title: "За нас",
    text: "<1>Пред неколку години, ни се обрати наш, сега веќе долгогодишен партнер со проблем што го имаше во своето секојдневно работење. Му беше потребна алатка што ќе му помогне да ги оптимизира процесите, поефикасно да ги извршува испитувањата и да генерира стручни наоди. Така настана Inspect Master – решение што го осмисливме како одговор на секојдневните предизвици и реалните проблеми од областа на проверката на безбедносните услови при работа. </1> <1>Inspect Master е продукт што го развива тимот на IT софтверската компанија Tremium Software, на кој секојдневно работиме посветено, внесувајќи најнови промени и функционалности. Се стремиме да останеме доследни на потребите на нашите партнери, но и да внесеме доволно новитети за да ја прошириме намената на нашата платформа. </1>",
  },
  sectionContact: {
    title: "Контактирајте нè",
    text: "Inspect Master Ви дава можност да ги изберете функционалностите што најмногу одговараат на Вашите потреби. За информации за ценовните понуди, како и за бесплатна пробна регистрација, контактирајте нè на е-маил: <1>im.support@tremium.net</1> или на телефонскиот број <2>+38160 366 02 71</2>",
  },
  privacyPolicy: {
    title: "Политика за приватност",
    lastUpdate: "Последно ажурирање: 11 март 2025 година",
    text: "Оваа Политика за приватност ги дефинира условите под кои Inspect Master ги собира, користи и обработува вашите лични податоци кога пристапувате или користите некој од нашите веб-сајтови или услуги. Оваа политика, меѓу другото, ги опишува видовите лични податоци кои ги собираме, целите за кои ги користиме, како и вашите права и обврски во однос на тие податоци.",
    definition: {
      title: "Дефиниции",
      definitions: [
        "<strong>Сметка</strong> се однесува на единствен кориснички профил креиран за пристап до нашата услуга или нејзини делови.",
        "<strong>Производ</strong> (во овој документ означен како „Производ“, „Ние“, „Нас“ или „Наш“) се однесува на Inspect Master.",
        "<strong>Колачиња</strong> се мали датотеки кои веб-сајтот ги поставува на вашиот компјутер, мобилен уред или друг уред, и кои содржат информации за вашето пребарување на тој веб-сајт.",
        "<strong>Земји</strong> на кои се однесува: Србија, Северна Македонија, Црна Гора, Швајцарија и земјите на Европската Унија.",
        "<strong>Лични податоци</strong> се информации кои се однесуваат на идентификувано или идентификувачко физичко лице.",
        "<strong>Податоци за користење</strong> се податоци кои автоматски се собираат при користење на услугата или од самата инфраструктура на услугата (на пр., времетраење на посета на одредена страница).",
        "<strong>Веб-сајт</strong> се однесува на Inspect Master, достапен на доменот <a href='https://www.inspectmaster.net'>www.inspectmaster.net</a>.",
      ],
    },
    personalData: {
      title: "Собирање и користење на вашите лични податоци",
      subtitle: "Видови податоци кои ги собираме",
      personalDataTitle: "Лични податоци",
      personalDataDescription:
        "При користење на нашата услуга, можеме да побараме одредени информации со кои може да ве идентификуваме или контактираме. Овие податоци може да вклучуваат, но не се ограничени на:",
      personalDataList: [
        "<strong>Е-пошта</strong>",
        "<strong>Име</strong>",
        "<strong>Презиме</strong>",
        "<strong>Телефонски број</strong>",
        "<strong>Име на компанија</strong>",
        "<strong>ДДВ број</strong>",
        "<strong>Адреса на компанијата</strong>",
        "<strong>Матичен број на фирмата</strong>",
        "<strong>Звање</strong>",
        "<strong>Број на лиценца</strong>",
        "<strong>Слика од потпис</strong>",
      ],
      usageData: "Податоци за користење",
      usageDataDescription: [
        "Овие податоци автоматски се собираат при користење на услугата. Може да вклучуваат информации како IP адреса, тип и верзија на прелистувач, страници што ги посетувате, датум и време на посета, време поминато на страниците, уникатни идентификатори на уредот и други дијагностички податоци.",
        "Ако пристапувате преку мобилен уред, можеме автоматски да собереме дополнителни информации како тип на уред, уникатен ID, IP адреса, оперативен систем, мобилен прелистувач и слични технички податоци.",
      ],
    },
    cookies: {
      title: "Технологии за следење и колачиња",
      text: "Користиме колачиња и слични технологии за следење на активноста на нашата услуга и зачувување на одредени информации.",
      browserCookiesSubtitle: "Колачиња од прелистувачот",
      browserCookiesText:
        "Колаче е мала датотека поставена на вашиот уред. Може да го подесите прелистувачот да ги одбива сите колачиња или да ве известува кога се испраќа колаче. Сепак, ако одбиете колачиња, можеби нема да можете да користите некои делови од нашата услуга.",
      subtitle: "Видови колачиња што ги користиме:",
      sessionCookiesTitle: "Неопходни колачиња",
      sessionCookiesList: [
        "<strong>Тип:</strong> Сесија",
        "<strong>Цел:</strong> Овозможуваат основна функционалност, како автентикација и спречување злоупотреба.",
      ],
      persistentCookiesTitle: "Колачиња за прифаќање на политиката",
      persistentCookiesList: [
        "<strong>Тип:</strong> Трајни",
        "<strong>Цел:</strong> Бележат дали сте ја прифатиле политиката за колачиња.",
      ],
      functionalityCookiesTitle: "Функционални колачиња",
      functionalityCookiesList: [
        "<strong>Тип:</strong> Трајни",
        "<strong>Цел:</strong> Ги паметат вашите избори (на пример, јазик или податоци за најава) за подобро корисничко искуство.",
      ],
    },
    usePersonalData: {
      title: "Користење на вашите лични податоци",
      text: "Вашите лични податоци може да се користат за:",
      list: [
        "<strong>Обезбедување и одржување на услугата</strong>, вклучително и следење на користењето",
        "<strong>Управување со вашата сметка</strong>, и пристап до кориснички функционалности",
        "<strong>Комуникација</strong>, преку е-пошта, повици, СМС или апликациски нотификации",
        "<strong>Испраќање на информации за новости, промоции и понуди</strong>, освен ако не се откажете",
        "<strong>Обработка и управување</strong> со вашите барања",
        "<strong>Анализа на податоци</strong>, следење трендови и подобрување на услугите и кампањите",
      ],
      share: "Може да ги споделиме вашите лични податоци во следниве ситуации:",
      shareList: [
        "<strong>Со ваша согласност</strong> - Кога е потребно по закон",
      ],
    },
    retentionPersonalData: {
      title: "Чување на вашите податоци",
      list: [
        "Вашите податоци ќе се чуваат онолку долго колку што е потребно за исполнување на правните обврски, решавање на спорови и спроведување на политики.",
        "Податоците за користење генерално се чуваат пократко, освен ако не се потребни за безбедност, подобрување или по закон.",
      ],
    },
    transferPersonalData: {
      title: "Пренос на вашите лични податоци",
      list: [
        "Со користење на услугата, се согласувате со евентуален пренос на вашите податоци во други земји. Преземаме разумни мерки за безбедно ракување со податоците во согласност со оваа Политика.",
        "Вашите податоци може да ги измените преку поставките на сметката или со контакт со нашата поддршка.",
      ],
    },
    disclosurePersonalData: {
      title: "Обелоденување на податоци по законски основ",
      textTitle: "Законски барања",
      text: "Под одредени околности, од Компанијата може да се бара да ги открие вашите лични податоци доколку тоа го бара закон или како одговор на валидни барања од јавни органи (на пр., суд или владина агенција).",
      otherLegalrequirements: "Законски барања",
      otherLegalrequirementsText:
        "Во одредени ситуации, може да бидеме обврзани да ги откриеме вашите информации во согласност со законот или врз основа на барања од владини органи, вклучувајќи:",
      otherLegalrequirementsList: [
        "За исполнување на законски обврски",
        "За заштита на нашите права и имот",
        "За истраги на потенцијални незаконски активности",
        "За заштита на корисници и јавноста",
        "За правна одбрана",
      ],
    },
    securityPersonalData: {
      title: "Безбедност на податоците",
      text: "Вашата приватност ни е важна. Сепак, ниту еден начин на пренос или складирање преку интернет не е 100% сигурен. Ќе примениме соодветни безбедносни мерки, но не можеме да гарантираме апсолутна заштита.",
    },
    changesPrivacyPolicy: {
      title: "Измени во Политиката за приватност",
      list: [
        "Може повремено да ја ажурираме оваа Политика. Ќе бидете известени преку е-пошта или преку известување на веб-сајтот. Ве советуваме да ја прегледувате периодично.",
      ],
    },
    contact: {
      title: "Контакт информации",
      text: "Доколку имате прашања поврзани со оваа Политика за приватност, можете да не контактирате на:",
    },
  },
};
